/* eslint-disable jsx-a11y/anchor-is-valid */
import './Navbar.scss'
import KBLogo from '../../../assets/logo/kb-logo-2.png'
import { User } from '@icons'
import { ChevronDown } from '../../../assets/icons'
import { LangToggle } from './Components'
import { useTranslation } from 'react-i18next'
import { SmtownAPI } from '../../api'
import { useEffect, useState } from 'react'

function Navbar() {
  const [data, setData] = useState()

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await SmtownAPI()
      if (
        data.data[0] !== undefined &&
        data.data[0].smtown_link !== '' &&
        data.data[0].smtown_link !== null &&
        data.data[0].smtown_link !== undefined
      ) {
        setData(data)
      }
    }

    fetchData()
  }, [])
  const { t } = useTranslation()

  return (
    <div className="custom-navbar">
      <nav className="navbar navbar-expand-lg navbar-light">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <img
              src="/kb-logo-2.png"
              height="24"
              className="d-inline-block align-top"
              alt="KB Bank"
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse justify-content-between"
            id="navbarNavDropdown"
          >
            <ul className="navbar-nav">
              <LangToggle />
            </ul>
            <ul className="navbar-nav">
              <li className="nav-item dropdown">
                {data && (
                  <a
                    className="nav-link dropdown-toggle"
                    href={data.data[0].smtown_link}
                  >
                    {t('smtown_live_2023')}
                  </a>
                )}
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  id="navbarDropdownKarir"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {t('solusi_untuk_anda')}
                  <img src={ChevronDown} alt="ChevronDown" />
                </a>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="navbarDropdownLayananKarir"
                >
                  <div className="dropdown-menu-box">
                    <div className="dropdown-menu-item">
                      <li>
                        <a className="dropdown-item header">
                          {t('solusi_keseharian_anda')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/credit-card"
                          rel="noreferrer"
                        >
                          {t('kartu_kredit')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/debit-card"
                          rel="noreferrer"
                        >
                          {t('kartu_debit')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/bukopin-priority"
                          rel="noreferrer"
                        >
                          {t('bukopin_prioritas')}
                        </a>
                      </li>

                      <li>
                        <a href="/promotion" className="dropdown-item header-2">
                          {t('promosi')}
                        </a>
                      </li>
                    </div>
                    <div className="dropdown-menu-item">
                      <li>
                        <a className="dropdown-item header">
                          {t('solusi_masa_depan_anda')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/savings"
                          rel="noreferrer"
                        >
                          {t('simpanan')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/loan"
                          rel="noreferrer"
                        >
                          {t('pinjaman')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/wealth-management"
                          rel="noreferrer"
                        >
                          {t('wealth_management')}
                        </a>
                      </li>
                    </div>
                    <div className="dropdown-menu-item">
                      <li>
                        <a className="dropdown-item header">
                          {t('solusi_untuk_bisnis_anda')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/business-solution/umkm"
                          rel="noreferrer"
                        >
                          {t('UMKM')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/business-solution/komersial"
                          rel="noreferrer"
                        >
                          {t('komersial')}
                        </a>
                      </li>
                    </div>
                    <div className="dropdown-menu-item">
                      <li>
                        <a className="dropdown-item header">
                          {t('layanan_terbaik_untuk_anda')}
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/individu-service">
                          {t('layanan_individual')}
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/bisnis-service">
                          {t('layanan_bisnis')}
                        </a>
                      </li>
                    </div>
                  </div>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  id="navbarDropdownKarir"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {t('tentang_kami')}
                  <img src={ChevronDown} alt="ChevronDown" />
                </a>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="navbarDropdownLayananKarir"
                >
                  <div className="dropdown-menu-box">
                    <div className="dropdown-menu-item">
                      <li>
                        <a className="dropdown-item header">
                          {t('profil_bank_bukopin')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/profile/history"
                          rel="noreferrer"
                        >
                          {t('riwayat_kami')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/profile/vision-mission"
                          rel="noreferrer"
                        >
                          {t('visi_misi')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/profile/business-segment"
                          rel="noreferrer"
                        >
                          {t('segmen_binis')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/profile/subsidiary"
                          rel="noreferrer"
                        >
                          {t('anak_perusahaan')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/profile/corporate-culture"
                          rel="noreferrer"
                        >
                          {t('budaya_perusahaan')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/profile/award"
                          rel="noreferrer"
                        >
                          {t('penghargaan')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/profile/correspondent-bank"
                          rel="noreferrer"
                        >
                          {t('bank_koresponden')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/profile/institute-bank"
                          rel="noreferrer"
                        >
                          {t('lembaga_profesi_perusahaan')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/profile/contact-us"
                          rel="noreferrer"
                        >
                          {t('hubungi_kami')}
                        </a>
                      </li>

                      <li>
                        <a className="dropdown-item header-2">
                          {t('tata_kelola_perusahaan')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/corporate-governance/about"
                          rel="noreferrer"
                        >
                          {t('tentang_tata_kelola_perusahaan')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/corporate-governance/piagam"
                          rel="noreferrer"
                        >
                          {t('piagam')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/corporate-governance/guidelines"
                          rel="noreferrer"
                        >
                          {t('pedoman')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/corporate-governance/report"
                          rel="noreferrer"
                        >
                          {t('laporan_tata_kelola')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/corporate-governance/code-of-ethics"
                          rel="noreferrer"
                        >
                          {t('kode_etik')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/corporate-governance/whistleblowing-system"
                          rel="noreferrer"
                        >
                          {t('whistleblowing_system')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/corporate-governance/privacy-notice"
                          rel="noreferrer"
                        >
                          {t('privacy_notice')}
                        </a>
                      </li>
                    </div>
                    <div className="dropdown-menu-item">
                      <li>
                        <a className="dropdown-item header">
                          {t('struktur_manajemen')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/structure-corporate/komisaris"
                          rel="noreferrer"
                        >
                          {t('dewankomisaris')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/structure-corporate/direksi"
                          rel="noreferrer"
                        >
                          {t('direksi_only')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/structure-corporate/komite"
                          rel="noreferrer"
                        >
                          {t('komite')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/structure-corporate/sekretarisperusahaan"
                          rel="noreferrer"
                        >
                          {t('sekretaris_perusahaan')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/structure-corporate/struktur-organisasi"
                          rel="noreferrer"
                        >
                          {t('struktur_organisasi')}
                        </a>
                      </li>
                    </div>

                    <div className="dropdown-menu-item">
                      <li>
                        <a className="dropdown-item header">{t('investor')}</a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/investor">
                          {t('hubungan_investor')}
                        </a>
                      </li>
                    </div>
                    <div className="dropdown-menu-item">
                      <li>
                        <a className="dropdown-item header">
                          {t('tanggung_jawab_sosial')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/csr-policy"
                          rel="noreferrer"
                        >
                          {t('kebijakan_tanggung_jawab_sosial_perusahaan')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="csr-activity"
                          rel="noreferrer"
                        >
                          {t('pelaksanaan_tanggung_jawab_sosial_perusahaan')}
                        </a>
                      </li>
                    </div>
                  </div>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="/info-terbaru"
                  id="navbarDropdownKarir"
                >
                  {t('info_terbaru')}
                </a>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  id="networkingMenu"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {t('jaringan')}
                  <img src={ChevronDown} alt="ChevronDown" />
                </a>
                <ul
                  className="dropdown-menu p-0 m-0"
                  aria-labelledby="networkingMenu"
                  data-bs-popper="none"
                >
                  <div className="dropdown-menu-box py-4">
                    <div className="dropdown-menu-item-wrapper">
                      <div className="dropdown-menu-item px-5 mb-4">
                        <a
                          href="/network/kantor"
                          className="dropdown-item header"
                        >
                          <li>{t('jaringan_kantor')}</li>
                        </a>
                      </div>
                    </div>
                    <div className="dropdown-menu-item-wrapper">
                      <div className="dropdown-menu-item px-5 mb-4">
                        <a href="/network/atm" className="dropdown-item header">
                          <li>{t('jaringan_atm')}</li>
                        </a>
                      </div>
                    </div>
                    <div className="dropdown-menu-item-wrapper"></div>
                    <div className="dropdown-menu-item-wrapper"></div>
                    <div className="dropdown-menu-item-wrapper"></div>
                    <div className="dropdown-menu-item-wrapper"></div>
                  </div>
                </ul>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  id="careerMenu"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {t('karir')}
                  <img src={ChevronDown} alt="ChevronDown" />
                </a>
                <ul
                  class="dropdown-menu p-0 m-0"
                  aria-labelledby="careerMenu"
                  data-bs-popper="none"
                >
                  <div class="dropdown-menu-box py-4">
                    <div class="dropdown-menu-item-wrapper">
                      <div class="dropdown-menu-item px-5 mb-4">
                        <a href="/career-work" class="dropdown-item header">
                          <li>{t('life_at_bukopin')}</li>
                        </a>
                      </div>
                    </div>
                    <div class="dropdown-menu-item-wrapper">
                      <div class="dropdown-menu-item px-5 mb-4">
                        <a href="/career-jobs" class="dropdown-item header">
                          <li>{t('lowongan_pekerjaan')}</li>
                        </a>
                      </div>
                    </div>
                    <div class="dropdown-menu-item-wrapper"></div>
                    <div class="dropdown-menu-item-wrapper"></div>
                    <div class="dropdown-menu-item-wrapper"></div>
                    <div class="dropdown-menu-item-wrapper"></div>
                  </div>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  id="navbarDropdownLayananNasabah"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {t('layanan_nasabah')}
                  <img src={ChevronDown} alt="ChevronDown" />
                </a>
                <ul
                  className="dropdown-menu p-0 m-0"
                  aria-labelledby="navbarDropdownLayananNasabah"
                  data-bs-popper="none"
                >
                  <div class="dropdown-menu-box py-4">
                    <div class="dropdown-menu-item-wrapper">
                      <div class="dropdown-menu-item px-5 mb-4">
                        <a href="/support-center" class="dropdown-item header">
                          <li>{t('layanan_pengaduan')}</li>
                        </a>
                      </div>
                    </div>
                    <div class="dropdown-menu-item-wrapper">
                      <div class="dropdown-menu-item px-5 mb-4">
                        <a
                          href="/transaction-service"
                          class="dropdown-item header"
                        >
                          <li>{t('layanan_transaksi')}</li>
                        </a>
                      </div>
                    </div>
                  </div>
                </ul>
              </li>
              <div className="nav-item">
                <a href="/search">
                  <button className="btn btn-icon-primary mx-2">
                    <i className="bi bi-search"></i>
                  </button>
                </a>
              </div>
              <div
                className="nav-item d-none"
                onClick={() =>
                  window.open('https://ib.bukopin.co.id/business/', '_blank')
                }
              >
                <button className="btn btn-primary align-items-center">
                  {' '}
                  <User /> Masuk <i className="bi bi-chevron-down"></i>
                </button>
              </div>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default Navbar
